/**
 * Единственный источник правды по контактам.
 *
 * Появился после ошибки, которая стоила бы заявок: как контакт «напишите
 * нам» на сайте стоял @yard_ro — а это КАНАЛ, в него нельзя написать.
 * Он был в футере, в блоке коммерческих факторов (с обещанием «отвечаем
 * в течение часа»), на странице автора и в микроразметке ContactPoint.
 * Человек, решившийся написать, упирался в ленту постов.
 *
 * Проверено запросом к t.me: @batyaro отдаёт «Антон Ро Батень» — это
 * личный аккаунт; @yard_ro и @ro_baten отдают «Ярд Ро» — оба юзернейма
 * одного канала, основной из них ro_baten; @ro_baten_cases — «Кейсы
 * Ро Батень».
 *
 * Отсюда правило: писать — только в личку, подписываться и смотреть —
 * в каналы. Страж tests/e2e/contacts.spec.ts не даёт их перепутать.
 */

/** Личный аккаунт Антона — сюда пишут. */
export const TG_PERSONAL = 'batyaro'
/** Канал (основной юзернейм; yard_ro — его же коллекционный алиас). */
export const TG_CHANNEL = 'ro_baten'
/** Канал с видеокейсами. */
export const TG_CASES = 'ro_baten_cases'

export const TG_PERSONAL_URL = `https://t.me/${TG_PERSONAL}`
export const TG_CHANNEL_URL = `https://t.me/${TG_CHANNEL}`
export const TG_CASES_URL = `https://t.me/${TG_CASES}`
